import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadFileActions } from '../../../store/ducks/download';
import type { RootState } from '../../../store';
import * as S from './styles';

interface DownloadButtonProps {
  fileKey: string;
  children: React.ReactNode;
}

interface DownloadedFile {
  uri?: string | null;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  fileKey,
  children,
}) => {
  const dispatch = useDispatch();

  const loading = useSelector((state: RootState) => state.downloadFile.loading);

  const handleClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (loading) return; // evita múltiplos cliques

    dispatch(
      DownloadFileActions.request(
        fileKey,
        (downloadedFile: DownloadedFile) => {
          if (downloadedFile?.uri) {
            window.open(downloadedFile.uri, '_blank', 'noopener,noreferrer');
          } else {
            console.warn('Link não disponível ainda');
          }
        },
        () => {
          console.warn('Erro ao tentar baixar o arquivo');
        }
      )
    );
  };

  return (
    <a
      href="#"
      style={{
        width: 'auto',
        height: 'auto',
        border: 0,
        padding: 0,
        margin: 0,
        outline: 0,
        textDecoration: 'none',
        cursor: loading ? 'wait' : 'pointer',
        opacity: loading ? 0.6 : 1,
        pointerEvents: loading ? 'none' : 'auto',
      }}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      {loading ? <S.ActivityIndicator /> : children}
    </a>
  );
};
